"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function default_1(rankingStatus) {
    var rank;
    if (rankingStatus > 0 && rankingStatus <= 100) {
        rank = "0to100";
    }
    else {
        rank = "100plus";
    }
    return rank;
}
exports.default = default_1;
